import { lazy } from 'react'

export const FinancialAnalyticsPage = lazy(() => import('./FinancialAnalyticsPage'))
